export default "/images/vendor/flag-icon-css/flags/4x3/ly.svg?86eec27b4d685f067ab523dff4b7a1ee";